import React from 'react';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';

export const DetailsPanelSkeleton = ({ count = 5 }) => {
  const skeletons = Array.from({ length: count }, () => Math.random().toString(36).substring(2));

  return (
    <>
      {skeletons.map(id => (
        <Box key={id} marginBottom={2}>
          <Skeleton variant="text" width="70%" height={34} role="progressbar" />
          <Skeleton variant="text" width="60%" height={28} role="progressbar" />
          <Skeleton variant="text" width="55%" height={28} role="progressbar" />
          <Skeleton variant="text" width="30%" height={24} role="progressbar" />
          <Skeleton
            variant="rect"
            width={140}
            height={24}
            style={{ borderRadius: 4 }}
            role="progressbar"
          />
        </Box>
      ))}
    </>
  );
};
